export const fastItems = [
  {
    name: "Stage 1",
    description: "No difficulty either subjectively or objectively.",
    value: "1",
    interpretation: "Normal Adults"
  },
  {
    name: "Stage 2",
    description: "Complains of forgetting location of objects. Subjective work difficulties.",
    value: "2",
    interpretation: "Normal Older Adults"
  },
  {
    name: "Stage 3",
    description: "Decreased job functioning evident to co-workers. Difficulty in travelling to new locations. Decreased organizational capacity.",
    value: "3",
    interpretation: "Early Alzheimer's Dementia"
  },
  {
    name: "Stage 4",
    description: "Decreased ability to perform complex task, (e.g., planning dinner for guests, handling personal finances, such as forgetting to pay bills, etc.)",
    value: "4",
    interpretation: "Mild Alzheimer's Dementia"
  },
  {
    name: "Stage 5",
    description: "Requires assistance in choosing proper clothing to wear for the day, season or occasion, (e.g. pt may wear the same clothing repeatedly, unless supervised.",
    value: "5",
    interpretation: "Moderate Alzheimer's Dementia"
  },
  {
    name: "Stage 6",
    description: "Requires physical assistance in dressing, bathing and toiletring. Urinary and fecal incontinence in the absence of infection or other etiologies.",
    value: "6",
    interpretation: "Moderately Severe Alzheimer's Dementia"
  },
  {
    name: "Stage 7",
    description: "Speech limited to about six words in the course of an average day. Progressive losses of abilities to walk, sit up, smile, and hold head up. Eligible for hospice.",
    value: "7",
    interpretation: "Severe Alzheimer's Dementia"
  }
]